import { humanize } from 'underscore.string';

// util functions for middleware
export function groupActionTypes(action) {
  return humanize(action.type);
}
